import { createEvent, createStore } from 'effector'
import { IScanQr } from '../types/user'


export const setScanQrFn = createEvent<(data: IScanQr, type: 'initial' | 'notInitial') => Promise<void>>()
export const $scanQrFn = createStore<((data: IScanQr, type: 'initial' | 'notInitial') => Promise<void>) | null>(null)
  .on(setScanQrFn, (_, fn) => fn)